import * as React from 'react';
import toastr from "toastr";
import AgSelectAllHeader from "../../common/AgSelectAllHeader";
import Utils from "../../../../Utils";
import {
    createNewRole,
    assignFunctionalitiesToRole,
    removeFunctionalitiesToRole,
    editRoleName,
    editRoleFunctionalities,
    deleteRole,
} from "../../../../actions/boCoreActions";
import CreateRoleModal from "./components/createUserModal/CreateRoleModal";
import Axios from "../../../../config/Axios";
import AgGridFooter from "../../common/AgGridFooter";
import AgHelpToolTip, {helpHeaderTemplate} from "../../common/AgHeaderHelpToolTip";
const AgGridReact = require('ag-grid-react').AgGridReact;
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import "./rolesGrid.css"
import {Prompt} from "react-router";
import history from "../../../../config/history";
import AgGridUtils from "../../../../AgGridUtils";
import AgGridHelpToolTip from "../../common/AgGridFilterHelpTooltip";
import TextAreaModal from "../../../common/TextAreaModal/TextAreaModal";
import AccessControlModal, {Access, GridType} from "../../../common/AccessControlModal/AccessControlModal";
import AssignedEndpointsAndRoutes from "../FunctionalitiesGrid/components/uiRotesAndEndpointsModal/AssignedEndpointsAndRoutes";
import {AttributeTypeEnum} from "../../enums/AttributeTypeEnum";

interface State {
    rolesColumnDefs: any;
    rolesGridApi: any;
    rolesColumnApi: any;
    funcsColumnDefs: any;
    funcsGridApi: any;
    funcsColumnApi: any;
    rowData: any;
    rowDataRoles: any;
    selectedRole: any;
    selectedRoleForEdit: any;
    modalData: any;
    loading: boolean;
    showModal: boolean;
    leave: boolean;
    isFilterChanged: boolean;
    areThereChanges: boolean;
    selectedRows: number;
    showFunctionalities: string
    textAreaModalParams: any;
    showRoleInfoModal: boolean;
    gridType: GridType;
    roles: any,
    showUIRoutesModal: boolean,
    apiEndpointsModal: any,
    serverSideError: boolean,
    uiRoutesModal: any
}

interface Props {
    renderInModal?: boolean,
}

enum Functionalities {
    SHOW_ALL = 'Show All',
    SHOW_ASSIGNED = 'Show Assigned'
}

const modifiedColumns = [
    {
        column: 'allowed',
        values: {
            allowed: true,
            denied: false
        }
    }
]

class RolesGrid extends React.Component<Props, State> {
    assignedFunctionalities:any = []
    textAreaModalRef: any;
    constructor(props) {
        super(props);
        this.state = {
            rolesColumnDefs: [],
            rowData: [],
            rowDataRoles: [],
            rolesGridApi: null,
            rolesColumnApi: null,
            funcsColumnDefs: [],
            funcsGridApi: null,
            funcsColumnApi: null,
            loading: false,
            showModal: false,
            leave: false,
            areThereChanges: false,
            selectedRole: null,
            selectedRoleForEdit: null,
            selectedRows: 0,
            showFunctionalities: Functionalities.SHOW_ALL,
            textAreaModalParams: null,
            modalData: {
                usedNames: [],
            },
            isFilterChanged: false,
            showRoleInfoModal: false,
            gridType: null,
            roles: [],
            showUIRoutesModal: false,
            apiEndpointsModal: null,
            uiRoutesModal: null,
            serverSideError: false
        };
        this.textAreaModalRef = React.createRef();
    }

    componentDidMount() {
        this.buildRolesGrid();
        this.buildFuncsGrid();
        document.addEventListener('keydown', this.keydownHandlerRoles);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownHandlerRoles);
    }

    keydownHandlerRoles = (e) => {
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 78) {
            Utils.$('#new-func-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 69) {
            Utils.$('#edit-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#delete-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 85) {
            Utils.$('#update-btn').click();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.ag-floating-filter-input')[index].focus();
                }
            }
        }
    };

    buildFuncsGrid = () => {
        const columnDefs = [
            {
                id: "",
                headerName: "ID",
                field: "id",
                headerTooltip: "id",
                type: 'text',
                width: 120,
                suppressSizeToFit: true,
                checkboxSelection: true,
                dataType: AttributeTypeEnum.INT,
                headerComponent: AgSelectAllHeader,
            },
            {
                field: 'functionalityName',
                headerName: "Functionality Name",
                tooltipField: 'Functionality Name',
                headerTooltip: "Functionality Name",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'description',
                headerName: "Description",
                tooltipField: 'Description',
                headerTooltip: 'Description',
                type: 'text',
                cellRenderer: this.cellRendererForTextArea,
            },
            {
                field: 'allowed',
                headerName: "Access",
                tooltipField: 'Access',
                headerTooltip: "Access",
                type: 'text',
                editable: true,
                cellEditor: 'agRichSelectCellEditor',
                cellEditorParams: {
                    values: ['Allowed', 'Denied']
                }
            },
            {
                field: 'apiEndpoints',
                headerName: "API Endpoints",
                tooltipField: 'API Endpoints',
                headerTooltip: "API Endpoints",
                type: 'text',
                width: 220,
                minWidth: 220,
                cellRenderer: this.endpointsCellRenderer
            },
            {
                field: 'uiRoutes',
                headerName: "UI Routes",
                tooltipField: 'UI Routes',
                headerTooltip: "UI Routes",
                type: 'text',
                cellRenderer: this.uiRoutesCellRenderer
            },
            {
                field: 'roles',
                headerName: "Roles",
                tooltipField: 'Roles',
                headerTooltip: "Roles",
                type: 'text',
                cellRenderer: (params) => {
                    return params.data.roles.map(item => item.roleName).join(', ')
                },
                hide: true,
                lockVisible: true
            },
            {
                field: 'allowedRoles',
                headerName: "Allowed Roles",
                tooltipField: 'Allowed Roles',
                headerTooltip: "Allowed Roles",
                type: 'text',
                cellRenderer: (params) => {
                    return params.data.allowedRoles.map(item =>item.roleName).join(', ')
                }
            },
            {
                field: 'deniedRoles',
                headerName: "Denied Roles",
                tooltipField: 'Denied Roles',
                headerTooltip: "Denied Roles",
                type: 'text',
                cellRenderer: (params) => {
                    return params.data.deniedRoles.map(item =>item.roleName).join(', ')
                }
            },
        ]
        this.setState({
            funcsColumnDefs: columnDefs,
        })
    }

    uiRoutesCellRenderer = (params: any) => {
        if (params.data.uiRoutes.length <= 2) {
            let str = ''
            params.data.uiRoutes.forEach(item => {
                str += `${item}` + '<br/>'
            })
            return `<div class="cell-text-wrap">${str}</div>`
        } else if (params.data.uiRoutes.length > 2) {
            const eDiv = document.createElement('div');
            eDiv.innerHTML = `<button title="Show All UI Routes" id="show-api-endpoints" class="grid-button-dark">Show All (${params.data.uiRoutes.length})</button>`;
            const eButton = eDiv.querySelectorAll('#show-api-endpoints')[0];
            eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%';

            eButton.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                Utils.blurTheActiveElements();
                this.setState({
                    uiRoutesModal: params
                }, () => this.showAssignedApiEndpoints())
            });

            return eDiv;
        }
    }

    endpointsCellRenderer = (params: any) => {
        if (params.data.apiEndpoints.length <= 2) {
            let str = ''
            params.data.apiEndpoints.forEach(item => {
                str += `${item.method} ${item.url}` + '<br/>'
            })
            return `<div class="cell-text-wrap">${str}</div>`
        } else if (params.data.apiEndpoints.length > 2) {
            const eDiv = document.createElement('div');
            eDiv.innerHTML = `<button title="Show All Api Endpoints" id="show-api-endpoints" class="grid-button-dark">Show All (${params.data.apiEndpoints.length})</button>`;
            const eButton = eDiv.querySelectorAll('#show-api-endpoints')[0];
            eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%';

            eButton.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                Utils.blurTheActiveElements();
                this.setState({
                    apiEndpointsModal: params
                }, () => this.showAssignedApiEndpoints())
            });

            return eDiv;
        }
    }

    cellRendererForTextArea = (params: any) => {
        const eDiv = document.createElement('div');
        eDiv.innerHTML = `<span style="max-width: calc(100% - 40px); word-wrap: break-word; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">${params.value}</span>
                            <span><button id="previewTxtBtn" style="float: right; background-color: transparent; border: transparent;">
                                <i class="fas fa-search fa-lg"></i></button></span>`;
        const eButton = eDiv.querySelectorAll('#previewTxtBtn')[0];
        eDiv.style.cssText = 'display: flex; white-space: initial; justify-content: space-between; width: 100%';

        eButton.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            Utils.blurTheActiveElements();
            this.showTextArea(event, params);
        });

        return eDiv;
    }

    showTextArea = (event, params) => {
        this.setState({
            textAreaModalParams: params,

        }, () => this.textAreaModalRef.current.open())
    }

    ServerSideDatasourceFunctionalities() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sortObj = AgGridUtils.generateSortData(params.request.sortModel);
                const sortKeys = Object.keys(sortObj);
                let sort = sortKeys.length > 0 ? `&sort=${sortKeys[0] + ';' + sortObj[sortKeys[0]]}` : '';
                let filter = AgGridUtils.generateFilterDataV2(params, modifiedColumns);
                const roleId = this.state.selectedRole ? this.state.selectedRole.id : -1;

                if (this.state.selectedRole === null) {
                    params.successCallback([], 0);
                    this.state.funcsGridApi.showNoRowsOverlay()
                    this.state.funcsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(0,
                        (limit * (page + 1)) > 0 ?
                            0: (limit * (page + 1)),
                        params.parentNode.gridApi.getSelectedRows().length);
                    return;
                }

                Axios.instanceV2.get(`functionality/all??size=${limit}&page=${page}&roleId=${roleId}${sort}&${filter}`)
                    .then((response: any) => {
                        const assignedFuncs = [];
                        const gridData = response.data.data.map(item => {
                            if (item.allowed !== null) {
                                item['removedByUser'] = false;
                                item.allowed = item.allowed === true ? 'Allowed' : 'Denied';
                                assignedFuncs.push(item);
                            }
                            return {
                                id: item.id,
                                functionalityName: item.functionalityName,
                                apiEndpoints: item.apiEndpoints,
                                uiRoutes: item.uiRoutes,
                                allowed: item.allowed,
                                roles: item.roles,
                                allowedRoles: item.allowedRoles,
                                deniedRoles: item.deniedRoles,
                                description: item.description,
                                addedByUser: false,
                                removedByUser: false
                            }
                        });

                        if (gridData.length === 0) {
                            this.state.funcsGridApi.showNoRowsOverlay()
                        }
                        try {
                            const lastRow = gridData.length < limit ? params.request.startRow + gridData.length : -1;
                            params.successCallback(gridData, lastRow);
                            this.state.funcsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(response.data.totalElements,
                                (limit * (page + 1)) > response.data.totalElements ?
                                    response.data.totalElements : (limit * (page + 1)),
                                params.parentNode.gridApi.getSelectedRows().length);

                            if (this.state.funcsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.isSelected()) {
                                this.state.funcsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.selectAll();
                            }

                            this.state.funcsGridApi.sizeColumnsToFit();
                            this.forceUpdate();
                            this.assignedFunctionalities = assignedFuncs
                            this.setState({
                                isFilterChanged: false,
                                serverSideError: false,
                                areThereChanges: false
                            })

                        } catch (e) {
                            console.error(e);
                        }

                    })
                    .catch((e) => {
                        this.setState({
                            serverSideError: true
                        })
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    }

    buildRolesGrid = () => {
        const rolesColumnDefs = [
            {
                field: 'roleName',
                headerName: "Role Name",
                tooltipField: 'Role Name',
                headerTooltip: "Role Name",
                headerComponent: AgSelectAllHeader,
                width: 120,
                minWidth: 120,
                type: 'text',
                dataType: AttributeTypeEnum.INT,
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'usersGroupsRoleInfo',
                headerName: "Assigned",
                tooltipField: 'Assigned',
                headerTooltip: "Assigned",
                sortable: false,
                filter: false,
                floatingFilter: false,
                width: 130,
                minWidth: 130,
                type: 'text',
                cellRenderer: (params: any) => {
                    const eDiv = document.createElement('div');
                    eDiv.innerHTML = `<button title="" id="show-assigned-users" class="btn-new-design center-text-btn" style="border-radius: 10%; width: 25px; height: 24px; font-size: 12px; font-weight: 700">U</button>
                                        <button title="" id="show-assigned-groups" class="btn-new-design center-text-btn" style="border-radius: 10%; width: 25px; height: 24px; font-size: 12px; font-weight: 700; margin-left: 8px">G</button>`

                    const eButtonUsersAssigned = eDiv.querySelectorAll('#show-assigned-users')[0];
                    const eButtonGroupsAssigned = eDiv.querySelectorAll('#show-assigned-groups')[0];
                    eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%; justify-content: center; padding: 3px 0 3px 0';

                    eButtonUsersAssigned.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        this.setAccessControlModalProps(GridType.USERS, [params.data.roleName]);
                    });

                    eButtonGroupsAssigned.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        this.setAccessControlModalProps(GridType.GROUPS, [params.data.roleName]);
                    });


                    return eDiv;
                }
            },
        ]
        this.setState({
            rolesColumnDefs: rolesColumnDefs,
        }, () => this.addFilterIndex())
    }

    setAccessControlModalProps = (gridType: GridType, roles: any) => {
        this.setState({
            gridType,
            roles
        }, () => this.showAccessControlModal())
    }

    ServerSideDatasourceRoles() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sortObj = AgGridUtils.generateSortData(params.request.sortModel);
                const sortKeys = Object.keys(sortObj);
                let sort = sortKeys.length > 0 ? `&sort=${sortKeys[0] + ';' + sortObj[sortKeys[0]]}` : '';
                let filter = AgGridUtils.generateFilterDataV2(params);

                const roleNames = [];
                Axios.instanceV2.get(`access-control/role/all?size=${limit}&page=${page}${sort}&${filter}`)
                    .then((response: any) => {
                        const gridData = response.data.data.map(item => {
                            roleNames.push(item.roleName);
                            return {
                                id: item.id,
                                roleName: item.roleName,
                            }
                        });

                        if (gridData.length === 0) {
                            this.state.rolesGridApi.showNoRowsOverlay()
                            if (this.state.funcsGridApi) {
                                this.setState({
                                    selectedRole: null,
                                    selectedRoleForEdit: null,
                                    modalData: {
                                        ...this.state.modalData,
                                        usedNames: []
                                    }
                                })
                                this.state.funcsGridApi.setFilterModel(null);
                                this.state.funcsGridApi.deselectAll();
                            }
                        }
                        try {
                            const lastRow = gridData.length < limit ? params.request.startRow + gridData.length : -1;
                            params.successCallback(gridData, lastRow);
                            this.state.rolesGridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true))

                            this.state.rolesGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(response.data.totalElements,
                                (limit * (page + 1)) > response.data.totalElements ?
                                    response.data.totalElements : (limit * (page + 1)),
                                params.parentNode.gridApi.getSelectedRows().length);
                            if (this.state.rolesGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.isSelected()) {
                                this.state.rolesGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.selectAll();
                            }

                            this.state.rolesGridApi.sizeColumnsToFit();
                            this.forceUpdate();
                            if (gridData.length > 0) {
                                setTimeout(() => {
                                    const selected = this.state.rolesGridApi.getSelectedRows();
                                    if (selected && selected.length > 0 && this.state.funcsGridApi) {
                                        this.setState({
                                            selectedRole: selected[0],
                                            selectedRoleForEdit: selected[0],
                                            rowDataRoles: gridData,
                                            modalData: {
                                                usedNames: roleNames
                                            }
                                        }, () => {
                                            this.showAssignedFuncs();
                                            // this.state.funcsGridApi.setServerSideDatasource(this.ServerSideDatasourceFunctionalities())
                                        });
                                    }
                                }, 100)
                            }
                        } catch (e) {
                            console.error(e);
                        }

                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
            }
        }
    }

    addFilterIndex = () => {
        Utils.$(".ag-floating-filter-input").each(function (index) {
            Utils.$(this).attr('id', 'roles-search-filter-' + index);
            Utils.$(this).attr('index', (index + 2));
        });
    };

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.rolesGridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.rolesColumnApi.getAllDisplayedColumns()[0];
            this.state.rolesGridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.rolesGridApi.setFocusedCell(0, currentCol);
        }
    };

    onCreateEditHandler = (type: string) => {
        Utils.blurTheActiveElements();
        if (type === 'edit') {
            const selected = this.state.rolesGridApi.getSelectedRows();
            if (selected && selected.length > 0) {
                const selectedRole = {
                    roleName: selected[0].roleName,
                    roleId: selected[0].id
                }
                this.setState({
                    selectedRole: selectedRole,
                    selectedRoleForEdit: selectedRole,
                    showModal: true
                })
            }
        } else {
            this.setState({
                selectedRoleForEdit: null,
                showModal: true
            })
        }
        document.removeEventListener('keydown', this.keydownHandlerRoles);
    }

    onDeleteHandler = () => {
        const selectedRows = this.state.rolesGridApi.getSelectedRows()
        if (selectedRows.length === 1) {
            Utils.blurTheActiveElements();
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                theme: 'dark',
                typeAnimated: false,
                content: `You are about to delete 1 role, this procedure is irreversible.`,
                type: 'red',
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            deleteRole(selectedRows[0].id)
                                .then(() => {
                                    this.state.rolesGridApi.deselectAll();
                                    this.state.rolesGridApi.onFilterChanged();
                                })
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        } else {
            toastr.warning("Please select one role");
        }
    }

    onSelectionChanged = () => {
        const selected = this.state.rolesGridApi.getSelectedRows();
        if (selected && selected.length > 0) {
            this.state.funcsGridApi.deselectAll();
            this.assignedFunctionalities = [];
            this.setState({
                selectedRole: selected[0],
                selectedRoleForEdit: selected[0],
            }, () => {
                this.showAssignedFuncs();
                this.setState({
                    showFunctionalities: Functionalities.SHOW_ALL
                })
                this.state.funcsGridApi.setServerSideDatasource(this.ServerSideDatasourceFunctionalities())
            })
        }
    }


    createRole = (dto: any) => {
        createNewRole(dto.roleName)
            .then(() => {
                this.state.rolesGridApi.onFilterChanged();
                this.state.funcsGridApi.deselectAll();
                this.hideModal();
            })
            .catch(() => {
                this.hideModal();
            })
    }

    editRole = async (dto: any) => {
        const requests = [];
        let noChanges = true;

        if (dto.roleName !== this.state.selectedRole.roleName) {
            requests.push(editRoleName(dto.roleId, dto.roleName));
            noChanges = false;
        }

        if (noChanges) {
            toastr.warning('There are no changes')
        } else {
            try {
                const [response] = await Promise.all(requests);
                if (response) {
                    this.state.rolesGridApi.onFilterChanged();
                    this.hideModal();
                }
            } catch (e) {
                this.hideModal();
            }
        }
    }

    restoreEventListener = () => {
        document.addEventListener('keydown', this.keydownHandlerRoles);
        $(this.refs.quickFilterBox).focus();
    }

    hideModal = () => {
        this.setState({
            selectedRoleForEdit: null,
            showModal: false,
        })
    }

    onGridReady = (params) => {
        this.setState({
            rolesGridApi: params.api,
            rolesColumnApi: params.columnApi
        }, () => {
            params.api.sizeColumnsToFit();
            params.api.setServerSideDatasource(this.ServerSideDatasourceRoles());
            // this.state.rolesGridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true))

            $("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    onFuncsGridReady = (params) => {
        this.setState({
            funcsGridApi: params.api,
            funcsColumnApi: params.columnApi
        }, () => {
            params.api.sizeColumnsToFit();
            $("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    updateRole = async() => {
        if (!this.state.serverSideError) {
            const requests = [];
            let noChanges = true;
            const selectedRole = this.state.rolesGridApi.getSelectedRows();
            const editedRows = this.getEditedFuncsRows();

            if (editedRows.added.length > 0) {
                noChanges = false;
                requests.push(assignFunctionalitiesToRole(selectedRole[0].id, editedRows.added));
            }

            if (editedRows.removed.length > 0) {
                requests.push(removeFunctionalitiesToRole(selectedRole[0].id, editedRows.removed));
                noChanges = false;
            }

            if (editedRows.editedFuncs.length > 0) {
                requests.push(editRoleFunctionalities(selectedRole[0].id, editedRows.editedFuncs));
                noChanges = false;
            }


            if (noChanges) {
                toastr.warning('There are no changes')
            } else {
                try {
                    const [response] = await Promise.all(requests);
                    if (response) {
                        this.setState({
                            areThereChanges: false
                        })
                        this.state.funcsGridApi.setServerSideDatasource(this.ServerSideDatasourceFunctionalities());
                        this.state.funcsGridApi.deselectAll();
                        this.state.funcsGridApi.redrawRows();
                    }
                } catch (e) {
                    toastr.error('Something went wrong')
                }
            }
        }
    }

    getEditedFuncsRows = () => {
        if (this.state.funcsGridApi) {
            let added = []
            let editedFuncs = []
            const selectedFuncs = this.state.funcsGridApi.getSelectedRows()
            const removed = this.assignedFunctionalities.filter(func => func.removedByUser === true).map(item => {return item.id})
            selectedFuncs.forEach(selectedItem => {
                const found = this.assignedFunctionalities.find(item => selectedItem.id === item.id)
                if (!found) {
                    added.push({
                        funcId: selectedItem.id,
                        allowed: selectedItem.allowed === 'Allowed',
                    })
                } else {
                    if (selectedItem.allowed !== found.allowed) {
                        editedFuncs.push({
                            funcId: selectedItem.id,
                            allowed: selectedItem.allowed === 'Allowed',
                        })
                    }
                }
            })
            return  {
                added: added,
                removed: removed,
                editedFuncs: editedFuncs,
            }
        }
        return  {
            added: [],
            removed: [],
            editedFuncs: [],
        }
    }

    confirmModal = (nextLocation: any) => {
        if (this.areThereChanges()) {
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                content: 'There are unsaved changes. Are you sure you want to continue?',
                type: 'red',
                theme: 'dark',
                typeAnimated: false,
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            this.setState({
                                leave: true
                            }, () => history.push(nextLocation))
                        }
                    },
                    cancel: () => {

                    }
                }
            });
            return false
        }
        return true
    }

    areThereChanges = ():boolean => {
        if (this.state.leave) {
            return false
        }
        if (this.state.isFilterChanged) {
            return false
        }
        const editedRows = this.getEditedFuncsRows();

        if (editedRows.added.length > 0) {
            return true
        }

        if (editedRows.removed.length > 0) {
            return true
        }

        if (editedRows.editedFuncs.length > 0) {
            return true
        }
        return false
    }

    selectAssignedFunc = (params: any) => {
        if (params) {
            this.assignedFunctionalities.forEach(item => {
                const found = params.api.getRowNode(item.id)
                if (found) {
                    if (!found.data.removedByUser) {
                        found.setSelected(true)
                    }
                    // found.selectable = false;
                }
            })
        }
    }

    cellEditorHandler = (params: any) => {
       if (params.data.allowed === null) {
           params.api.stopEditing();
           return;
       }
    }

    onSelectionFuncChange = () => {
        this.setState({
            areThereChanges: this.areThereChanges(),
            selectedRows: this.state.funcsGridApi ? this.state.funcsGridApi.getSelectedRows().length : 0
        })
    }

    onCellValueChangedHandler = () => {
        this.setState({
            areThereChanges: this.areThereChanges()
        })
    }

    showHideFunctionalities = () => {
        this.state.funcsGridApi.deselectAll();
        if (this.state.showFunctionalities === Functionalities.SHOW_ALL) {
            const filterModel = this.state.funcsGridApi.getFilterModel();
            const filterKeys = Object.keys(filterModel);
            if (filterKeys.includes('roles')) {
                delete filterModel.roles;
            }
            this.state.funcsGridApi.setFilterModel(filterModel);
            this.setState({
                showFunctionalities: Functionalities.SHOW_ASSIGNED,
                isFilterChanged: true
            })
        } else {
            this.showAssignedFuncs();
            this.state.funcsGridApi.onFilterChanged();
            this.setState({
                showFunctionalities: Functionalities.SHOW_ALL,
                isFilterChanged: true
            })
        }
    }

    showAssignedFuncs = () => {
        if (this.state.selectedRole) {
            let ageFilterComponent = this.state.funcsGridApi.getFilterInstance('roles');
            ageFilterComponent.setModel({
                type: 'contains',
                filter: `=="${this.state.selectedRole.roleName}"`,
                filterTo: null,
            });
        }
    }

    showAccessControlModal = () => {
        this.setState({
            showRoleInfoModal: true
        })
    }

    hideAccessControlModal = () => {
        this.setState({
            showRoleInfoModal: false,
            gridType: null,
        })
    }

    showAssignedApiEndpoints = () => {
        this.setState({
            showUIRoutesModal: true
        })
    }

    hideAssignedApiEndpoints = () => {
        this.setState({
            showUIRoutesModal: false,
            apiEndpointsModal: null,
            uiRoutesModal: null
        })
    }

    onFuncsGridFilterChanged = () => {
        this.setState({
            isFilterChanged: true
        }, () => {
            AgGridUtils.deselectAllRows(this.state.funcsGridApi)
        })
    }

    render() {
        return (
            <div style={{ height: '100%'}} className={'access-control-grid'}>
                <header style={{height: 50, display: "flex", justifyContent: "space-between", alignItems: 'center'}} className="bo-core-header top-header">
                    <div style={{paddingLeft: 4, width: '100%'}}>
                        <span id="rolesSearchTitle" style={{paddingTop: 3}} className="header-title">Roles</span>
                        <div className="control-buttons">
                            <button onClick={() => this.onCreateEditHandler('new')} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'new-func-btn'} title={'CTRL + ALT + N'}>
                                <i className="fas fa-plus"/> <strong style={{fontSize: '13px'}}
                                                                     className={'shortcut-btn-letters'}>N</strong>ew
                            </button>
                            <button onClick={() => this.onCreateEditHandler('edit')} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'edit-btn'} title={'CTRL + ALT + E'}>
                                <i className="fas fa-edit"/>
                                <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>E</strong>dit
                            </button>
                            <button onClick={() => this.updateRole()}
                                    style={{marginRight: 2, height: 36}}
                                    className= {`btn btn-new-design ${this.state.areThereChanges && !this.state.serverSideError ? 'changes-triggered' : ''}`}
                                    id={'update-btn'} title={'CTRL + ALT + U'}>
                                <i className="fas fa-save"/>&nbsp;
                                <strong style={{fontSize: '13px'}} className={'shortcut-btn-letters'}>U</strong>pdate
                            </button>
                            <button onClick={this.onDeleteHandler} style={{height: 36}}
                                    id={'delete-btn'}
                                    title={'CTRL + ALT + D'}
                                    className="btn btn-danger">
                                <i className="fas fa-trash-alt"/> <strong style={{fontSize: '13px'}}
                                                                          className={'shortcut-btn-letters'}>D</strong>elete
                            </button>
                        </div>
                    </div>
                </header>

                <div id={'roles-grids-container'}
                     style={{width: "100%", height: "calc(100% - 105px)", display: "flex", justifyContent: 'space-between', padding: 10}}>

                    <div style={{width: "18%", minWidth: 250, height: "100%"}}>
                        <header className={'instance-layout-grid-header'} style={{height: 40}}><h5>Roles</h5></header>
                        <div style={{width: "100%", height: "99%"}} id={'roles-grid'}
                             className={"ag-theme-balham-dark ag-grids"}>
                            <AgGridReact
                                onGridReady={this.onGridReady}
                                columnDefs={this.state.rolesColumnDefs}
                                onSelectionChanged={this.onSelectionChanged}
                                onFilterChanged={() => AgGridUtils.deselectAllRows(this.state.rolesGridApi)}
                                defaultColDef={{
                                    minWidth: 150,
                                    flex: 1,
                                    filter: "agTextColumnFilter",
                                    floatingFilter: true,
                                    sortable: true,
                                    autoHeight: true,
                                    resizable: true,
                                    tooltipComponent: AgGridHelpToolTip,
                                    headerComponentParams: {
                                        template: helpHeaderTemplate
                                    },
                                    filterParams: {
                                        filterOptions: ['contains'],
                                        applyButton: true,
                                        clearButton: true,
                                        suppressAndOrCondition: true
                                    },
                                    floatingFilterComponentParams: {suppressFilterButton: true},
                                }}
                                gridOptions={{
                                    rowSelection: 'single',
                                    rowModelType: 'serverSide',
                                    getRowNodeId: function (data) {
                                        return data.id;
                                    },
                                    floatingFilter: true,
                                    suppressDragLeaveHidesColumns: true,
                                    suppressCellSelection: true
                                }}
                            >
                            </AgGridReact>
                            <AgGridFooter
                                totalCount={this.state.rolesGridApi ? this.state.rolesGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                                loadedCount={this.state.rolesGridApi ? this.state.rolesGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                            />
                        </div>
                    </div>

                    <div id={'spacer-div'}/>

                    <div style={{width: "82%", height: "100%"}}>
                        <header className={'instance-layout-grid-header'} style={{height: 40}}>
                                <h5>Role Assigned Functionalities</h5>
                                <button onClick={this.showHideFunctionalities} style={{height: 33, marginTop: 3, marginRight: 3}}
                                        className="btn new-style-btn">{this.state.showFunctionalities}</button>
                        </header>
                        <div style={{width: "100%", height: "99%"}} id={'roles-functionalities-grid'}
                             className={"ag-theme-balham-dark ag-grids"}>
                            <AgGridReact
                                onGridReady={this.onFuncsGridReady}
                                onFirstDataRendered={this.onFuncsGridReady}
                                columnDefs={this.state.funcsColumnDefs}
                                onFilterChanged={this.onFuncsGridFilterChanged}
                                defaultColDef={{
                                    minWidth: 150,
                                    flex: 1,
                                    filter: "agTextColumnFilter",
                                    floatingFilter: true,
                                    sortable: true,
                                    autoHeight: true,
                                    singleClickEdit: true,
                                    resizable: true,
                                    tooltipComponent: AgGridHelpToolTip,
                                    headerComponentParams: {
                                        template: helpHeaderTemplate
                                    },
                                    filterParams: {
                                        filterOptions: ['contains'],
                                        applyButton: true,
                                        clearButton: true,
                                        suppressAndOrCondition: true
                                    },
                                    floatingFilterComponentParams: {suppressFilterButton: true},
                                }}
                                gridOptions={{
                                    rowModelType: 'serverSide',
                                    rowSelection: 'multiple',
                                    getRowNodeId: function (data) {
                                        return data.id;
                                    },
                                    floatingFilter: true,
                                    suppressDragLeaveHidesColumns: true,
                                    suppressCellSelection: true,
                                    suppressRowClickSelection: true,
                                    onSelectionChanged: this.onSelectionFuncChange,
                                    onCellValueChanged: this.onCellValueChangedHandler,
                                    onPaginationChanged: params => this.selectAssignedFunc(params),
                                    onFirstDataRendered: params => this.selectAssignedFunc(params),
                                    rowClassRules: {
                                        'deleted-relationship-row-background': (params: any) => {
                                            let rel;
                                            if (this.assignedFunctionalities.length > 0 && params.node.data) {
                                                const copy = JSON.parse(JSON.stringify(this.assignedFunctionalities))
                                                rel = copy.find(item => item.id === params.node.data.id);
                                                if (rel) {
                                                    return params.node.data.removedByUser === true;
                                                }
                                            }
                                        },
                                        'add-new-user-to-group': params => {
                                            if (params.node.data) {
                                                return params.node.data.addedByUser === true;
                                            }
                                        }
                                    },
                                    onRowSelected: (params: any) => {
                                        if (this.state.selectedRole) {
                                            const func = this.assignedFunctionalities.find(item => item.id === params.node.data.id);
                                            if (func) {
                                                func['removedByUser'] = !params.node.selected;
                                            } else {
                                                params.node.data.addedByUser = params.node.selected;
                                                params.node.data.allowed = params.node.selected ? 'Allowed' : null;
                                            }
                                            params.node.data.removedByUser = !params.node.selected;
                                            params.api.redrawRows();
                                        }
                                    },
                                    onCellEditingStarted: this.cellEditorHandler
                                }}
                            >
                            </AgGridReact>
                            <AgGridFooter
                                totalCount={this.state.funcsGridApi ? this.state.funcsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().totalItemsCount : 0}
                                loadedCount={this.state.funcsGridApi ? this.state.funcsGridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().loadedItemsCount : 0}
                                selectedCount={this.state.funcsGridApi ? this.state.selectedRows : 0}
                            />
                        </div>
                    </div>
                </div>
                <CreateRoleModal createRole={this.createRole}
                                 restoreEventListener={this.restoreEventListener}
                                 hideModal={this.hideModal}
                                 showModal={this.state.showModal}
                                 selectedRole={this.state.selectedRoleForEdit}
                                 modalData={this.state.modalData}
                                 editRole={this.editRole}
                />
                <TextAreaModal readOnly={true}
                               gridParams={this.state.textAreaModalParams}
                               modalRef={this.textAreaModalRef}
                />
                <AccessControlModal modalTitle={`${this.state.gridType} With ${this.state.roles[0]} Role`}
                                    showModal={this.state.showRoleInfoModal}
                                    gridType={this.state.gridType}
                                    // access={this.state.access}
                                    // modalFuncInfo={this.state.modalFuncInfo}
                                    roles={this.state.roles}
                                    closeModal={this.hideAccessControlModal}
                />
                <AssignedEndpointsAndRoutes showModal={this.state.showUIRoutesModal}
                                            hideModal={this.hideAssignedApiEndpoints}
                                            apiEndPoints={this.state.apiEndpointsModal}
                                            uiRoutes={this.state.uiRoutesModal}
                />
                <Prompt message={this.confirmModal}/>
            </div>
        );
    }
}

export default RolesGrid



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/RolesGrid/RolesGrid.tsx